import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../lib/constants';
export function WhatsAppBubble() {
  return <motion.div className="fixed bottom-6 right-6 z-50" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} data-id="element-284">
      <motion.a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-16 h-16 bg-mobal-green text-mobal-black rounded-full shadow-2xl hover:bg-[#b5ff33] transition-colors" aria-label="Contactar por WhatsApp" animate={{
      boxShadow: ['0 0 0px rgba(163,255,0,0.4)', '0 0 20px rgba(163,255,0,0.8)', '0 0 0px rgba(163,255,0,0.4)']
    }} transition={{
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} data-id="element-285">
        <MessageCircle className="w-8 h-8" data-id="element-286" />
      </motion.a>
    </motion.div>;
}